import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { Button } from "@mui/material";
import { useCallback, useMemo } from "react";
import LandingScreenHeader from "../../../components/Comman/LandingScreenHeader";
import {
  checkboxColor,
  lightPinkColor,
  offWhiteColor,
  white,
} from "../../../config/ColorObj";
import {
  exportTxt,
  importRuWiseTargetMsg,
  importTxt,
  noDataFoundMsg,
} from "../../../config/messageconstant";
import tableStyles from "../../../Styles/csvImportingValidation";
import { RU_TARGET_COLUMNS } from "../constants/columns";
import { tableHeaderButtonStyles as styles } from "../styles/importPopupStyles";
import { filterValidatedRows } from "../utils/filterValidatedRows";
import { getRowErrorMessage } from "../utils/validationHelpers";

const getCellValue = (col, row) => {
  if (col.isError) {
    return Number(row.flag) === 1 ? getRowErrorMessage(row) : null;
  }
  return row?.[col.field];
};

const RuWiseTargetTable = ({
  onClickOfExport,
  onClickOfImport,
  searchValue,
  onSearchBox,
  validatedProductList,
}) => {
  const filteredData = useMemo(
    () => filterValidatedRows(validatedProductList, searchValue),
    [validatedProductList, searchValue]
  );

  const handleMouseEnter = useCallback((e) => {
    e.currentTarget.style.backgroundColor =
      tableStyles.dataRowHover.backgroundColor;
  }, []);

  const handleMouseLeave = useCallback((e, row, index) => {
    e.currentTarget.style.backgroundColor =
      Number(row.flag) === 1
        ? lightPinkColor
        : index % 2 === 0
          ? tableStyles.alternateRow.backgroundColor
          : tableStyles.dataRow.backgroundColor;
  }, []);

  return (
    <>
      <div style={styles.headerRow}>
        <LandingScreenHeader
          screenTitle={importRuWiseTargetMsg}
          showSaveBtnMain={false}
          showAddButton={false}
          showBackButton={false}
        />

        <div style={styles.buttonGroup}>
          <Button
            variant="outlined"
            color="secondary"
            size="medium"
            startIcon={<CloudDownloadIcon />}
            sx={{
              ...styles.exportButton,
              "&:hover": {
                backgroundColor: offWhiteColor,
                borderColor: checkboxColor,
                color: checkboxColor,
                transform: "translateY(-2px)",
              },
            }}
            onClick={onClickOfExport}
          >
            {exportTxt}
          </Button>
          <Button
            variant="contained"
            color="primary"
            size="medium"
            startIcon={<CloudUploadIcon sx={{ color: white }} />}
            sx={styles.importButton}
            onClick={onClickOfImport}
          >
            {importTxt}
          </Button>
        </div>
      </div>
      <br />

      <div style={styles.searchRow}>
        <input
          type="text"
          placeholder="Search..."
          value={searchValue}
          onChange={onSearchBox}
          style={styles.searchInput}
        />
      </div>

      <div style={tableStyles.tableWrapper}>
        <table style={tableStyles.table}>
          <thead style={tableStyles.stickyHeader}>
            <tr style={tableStyles.headerRow}>
              <th style={{ ...tableStyles.headerCell, minWidth: "60px" }}>
                Sr.No
              </th>
              {RU_TARGET_COLUMNS.map((col) => (
                <th
                  key={col.key}
                  style={{
                    ...tableStyles.headerCell,
                    minWidth: `${col.minWidth}px`,
                    textAlign: col.align,
                  }}
                >
                  {col.label}
                </th>
              ))}
            </tr>
          </thead>

          <tbody>
            {validatedProductList.length === 0 ? (
              <tr>
                <td
                  colSpan={RU_TARGET_COLUMNS.length + 1}
                  style={tableStyles.noData}
                >
                  {noDataFoundMsg}
                </td>
              </tr>
            ) : (
              filteredData.map((row, index) => {
                const isError = Number(row.flag) === 1;

                return (
                  <tr
                    key={index}
                    style={{
                      ...tableStyles.dataRow,
                      ...(index % 2 === 0 ? tableStyles.alternateRow : {}),
                      ...(isError && { backgroundColor: lightPinkColor }),
                    }}
                    onMouseEnter={handleMouseEnter}
                    onMouseLeave={(e) => handleMouseLeave(e, row, index)}
                  >
                    <td
                      style={{
                        ...tableStyles.dataCell,
                        minWidth: "60px",
                        textAlign: "center",
                      }}
                    >
                      {index + 1}
                    </td>

                    {RU_TARGET_COLUMNS.map((col) => {
                      const value = getCellValue(col, row);
                      return (
                        <td
                          key={col.key}
                          style={{
                            ...tableStyles.dataCell,
                            minWidth: `${col.minWidth}px`,
                            textAlign: col.align,
                          }}
                        >
                          {value || "-"}
                        </td>
                      );
                    })}
                  </tr>
                );
              })
            )}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default RuWiseTargetTable;
